import React, { useCallback, useState } from "react";
import { Box, Button } from "@mui/material";

import {
  UnfoldMore as ExpandAllIcon,
  UnfoldLess as CollapseAllIcon,
} from "@mui/icons-material";
import ActivityCard from "./ActivityCard";
import { useTranslation } from "react-i18next";

/**
 * Huvudkomponent för listan av aktiviteter
 */
const ActivityLogTable = ({
  activities,
  cargoActivities,
  handleActivityChange,
  setNow,
  editableActivities,
  toggleEditable,
  getLabel,
  readOnly,
  isActivityEmpty,
}) => {
  const { t } = useTranslation("statementoffact");

  // State för vilka accordions som är öppna. Tomt objekt = alla stängda (Default).
  const [expandedItems, setExpandedItems] = useState({});

  // Expandera/Stäng alla
  const handleToggleAll = useCallback((expand) => {
    const newState = {};
    if (expand) {
      Object.keys(activities).forEach((key) => {
        newState[key] = true;
      });
    }
    setExpandedItems(newState);
  }, [activities]);

  // Hantera manuell expansion (klick på pilen)
  const handleAccordionChange = useCallback((activity, isExpanded) => {
    setExpandedItems((prev) => ({
      ...prev,
      [activity]: isExpanded,
    }));
  }, []);

  // Wrapper för edit-knappen: Vi vill att raden öppnas när man börjar edita
  const handleEditToggle = useCallback((activity) => {
    const currentlyEditable = !!editableActivities[activity];

    // Om vi precis ska BÖRJA edita (inte spara), öppna accordionsen
    if (!currentlyEditable) {
      setExpandedItems((prev) => ({
        ...prev,
        [activity]: true,
      }));
    }

    toggleEditable(activity);
  }, [editableActivities, toggleEditable]);

  return (
    <Box>
      <Box sx={{ mb: 2, display: "flex", gap: 1, justifyContent: "flex-end" }}>
        <Button
          size="small"
          startIcon={<ExpandAllIcon />}
          onClick={() => handleToggleAll(true)}
          disabled={readOnly}
          sx={{ fontWeight: 700, borderRadius: 2 }}
        >
          {t("expandAll")}
        </Button>
        <Button
          size="small"
          variant="text"
          color="inherit"
          startIcon={<CollapseAllIcon />}
          onClick={() => handleToggleAll(false)}
          disabled={readOnly}
          sx={{ fontWeight: 700, borderRadius: 2, opacity: 0.7 }}
        >
          {t("collapseAll")}
        </Button>
      </Box>

      {Object.keys(activities).map((activity) => {
        const activityData = cargoActivities?.[activity];
        const editable = !!editableActivities[activity];
        const empty = isActivityEmpty(activityData);
        const status = editable ? "editing" : empty ? "empty" : "saved";

        return (
        <ActivityCard
          key={activity}
          activity={activity}
          schema={activities[activity]}
          data={activityData}
          isEditable={editable}
          readOnly={readOnly}
          status={status}
          onToggle={handleEditToggle} // Använder vår smarta wrapper
          onUpdate={handleActivityChange}
          onSetNow={setNow}
          getLabel={getLabel}
          expanded={!!expandedItems[activity]}
          onAccordionChange={handleAccordionChange}
        />
        );
      })}
    </Box>
  );
};

export default ActivityLogTable;
